import {eachMonthOfInterval, endOfMonth, format, startOfMonth, subMonths, addMonths} from 'date-fns'
import {ENHANCEMENT_TYPE_COLOR_MAP} from './chartConfig'
import {EnhancementReportStat} from '../../../../models/enhancement/enhancement-report-stats'
import {PeriodType} from '../../PeriodTypeSelector'
import {generatePayPeriodLabelsFromData} from '../../../../utils/payPeriodUtils'

export type LineChartData = Record<string, Record<string, number>>

export function generateMonthLabels(dateFrom?: Date | string | null, dateTo?: Date | string | null): string[] {
  const start = dateFrom ? new Date(dateFrom) : startOfMonth(new Date())
  const end = dateTo ? new Date(dateTo) : endOfMonth(new Date())
  
  if (start > end) {
    return []
  }

  const interval = eachMonthOfInterval({
    start,
    end
  })

  return  interval.map(date => format(date, 'MMM yyyy'))
}

export const createLabelCounter = (labels: string[]) =>
  Object.fromEntries(labels.map(label => [label, 0]))

export function processChartData(
  reportData: EnhancementReportStat[],
  dateFrom: Date | string | null | undefined,
  dateTo: Date | string | null | undefined,
  selectedRequestTypes?: string[] | null,
  periodType: PeriodType = PeriodType.MONTH
): LineChartData {
  let labels: string[]

  if (periodType === PeriodType.PAY_PERIOD) {
    labels = generatePayPeriodLabelsFromData(reportData || [])
  } else {
    const startDate = dateFrom ? new Date(dateFrom) : startOfMonth(new Date())
    const endDate = dateTo ? new Date(dateTo) : endOfMonth(new Date())
    labels = generateMonthLabels(startDate, endDate)
  }
  
  const filteredData = selectedRequestTypes && selectedRequestTypes.length > 0
    ? reportData.filter(item => selectedRequestTypes.includes(item.requestType))
    : reportData
  
  const requestTypesToShow = selectedRequestTypes && selectedRequestTypes.length > 0
    ? selectedRequestTypes.filter(type => Object.keys(ENHANCEMENT_TYPE_COLOR_MAP).includes(type))
    : Object.keys(ENHANCEMENT_TYPE_COLOR_MAP)

  const initialCounter = Object.fromEntries(
    requestTypesToShow.map(requestType =>
      [requestType, createLabelCounter(labels)]
    )
  )

  return filteredData.reduce((acc, item) => {
    const groupingValue = periodType === PeriodType.PAY_PERIOD ? item.payPeriod : item.month
    const {requestType, finalPaidHours} = item

    if (groupingValue && labels.includes(groupingValue) && acc[requestType]) {
      acc[requestType][groupingValue] += (finalPaidHours ?? 0)
    }

    return acc
  }, initialCounter as LineChartData)
}